module.exports = __webpack_public_path__ + "static/brandonheatshot-a22654f0f101faf83967ff4953d76e84.jpg";